import './FilterMenu.scss';
import classNames from 'classnames';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { FilterDisplay } from './FilterDisplay';
import { FilterOutlined } from '@ant-design/icons';
import { getTitleWithCount } from '@sonar-software/sonar-ts-lib';
import { SonarText } from '@ui/text';
import { Button, Drawer } from 'antd';
import { Else, If, Then } from 'react-if';
import React, { useCallback, useEffect, useMemo } from 'react';
import { useBoolean, usePrevious, useQueryParams } from '@hooks';
export const FilterMenu = ({ deferFiltering, filters, filterParams, sonarObjectId, sonarObjectType, updateFilterParams }) => {
    const [open, setOpen] = useBoolean();
    const prevFilterParams = usePrevious(filterParams, filterParams);
    const { queryParams, updateParams } = useQueryParams({
        defaultParams: filterParams
    });
    useEffect(() => {
        if (prevFilterParams !== filterParams) {
            updateParams(filterParams);
        }
    }, [filterParams, prevFilterParams, updateParams]);
    const handleClose = useCallback(() => {
        if (deferFiltering) {
            updateFilterParams(queryParams);
        }
        setOpen.off();
    }, [deferFiltering, queryParams, setOpen, updateFilterParams]);
    const groups = useMemo(() => {
        if (!filters.some((filter) => Boolean(filter.filterGroup))) {
            return [];
        }
        return [...new Set(filters.map((filter) => filter.filterGroup))];
    }, [filters]);
    const hasGroups = Boolean(groups.length);
    function mapFilter(filter) {
        return (React.createElement(FilterDisplay, { filter: filter, filterParams: deferFiltering ? queryParams : filterParams, key: filter.filterId, sonarObjectId: sonarObjectId, sonarObjectType: sonarObjectType, updateFilterParams: deferFiltering ? updateParams : updateFilterParams }));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { className: classNames('filter-menu-button', { active: Boolean(filterParams.filterCount) }), icon: React.createElement(FilterOutlined, null), onClick: setOpen.toggle, type: 'text' }, getTitleWithCount(COPY_SPECIFIC.FILTERS, filterParams.filterCount)),
        React.createElement(Drawer, { className: 'data-dictionary-filter-drawer', footer: deferFiltering ?
                React.createElement(Button, { onClick: handleClose, type: 'primary' }, COPY_SPECIFIC.APPLY_FILTERS) : undefined, mask: Boolean(deferFiltering), onClose: handleClose, open: open, title: React.createElement(SonarText, { size: 20, weight: 'semibold' }, COPY_SPECIFIC.ADD_FILTERS) },
            React.createElement("div", { className: 'filters' },
                React.createElement(If, { condition: hasGroups },
                    React.createElement(Then, null, filters === null || filters === void 0 ? void 0 :
                        filters.filter((filter) => !filter.filterGroup).map(mapFilter),
                        groups.map((group) => React.createElement(React.Fragment, { key: group },
                            React.createElement(SonarText, { size: 16, weight: 'semibold' }, group),
                            filters.filter((filter) => filter.filterGroup === group).map(mapFilter)))),
                    React.createElement(Else, null, filters.map(mapFilter)))))));
};
